import { cms_logging } from "./cms_logging";
import { Dispatcher, BatchedDispatcher } from "./redux/Dispatcher";
import { Actions, Action } from "./redux/Actions";
import { Keys } from "./redux/Datastore";
import { QueryString } from "./QueryString";
import { State } from "./redux/State";
import { exists } from "./utils";
import { Configuration } from "./Configuration";

function reload_all() {
    //    get_work_order_query();
    //    refetchAllData() // a re-fetch the data from the API to update the state and force the UI to be redrawn.
}

export function initialize(is_ios_app: boolean): void {
    if (is_ios_app) {
        var menu_attachments_container = document.getElementById("menu_attachments_container");
        if (menu_attachments_container) {
            menu_attachments_container.removeChild(document.getElementById("menu_attachments_content"));
        }
    }
    let bd: BatchedDispatcher = new BatchedDispatcher();

    bd.add(Action.set_key_boolean(Keys.ENABLED_FEATURE_ASSETS, Configuration.assets_feature_enabled));

    bd.add(Action.set_key_boolean(Keys.ENABLED_FEATURE_ATTACHMENTS, Configuration.attachments_feature_enabled));
    bd.add(Action.set_key_boolean(Keys.ENABLED_FEATURE_FINDINGS, Configuration.findings_feature_enabled));
    bd.add(Action.set_key_boolean(Keys.ENABLED_FEATURE_SPOTSHADOW,  Configuration.spotshadow_feature_enabled));
    if(exists(QueryString.workorder_query)){
        bd.add(Action.set_workorder_query(QueryString.workorder_query));
    }
    bd.dispatch();

    if (!Configuration.assets_feature_enabled) {
        document.getElementById("menu_assets_container").innerHTML = "";
    }
    // if (!Configuration.rpt_feature_enabled) {
    //     document.getElementById('menu_fsi_private_container').innerHTML = "";
    // }

    if (!Configuration.attachments_feature_enabled) {
        document.getElementById("menu_attachments_container").innerHTML = "";
    }
    if(!Configuration.workorders_feature_enabled){
        document.getElementById("menu_workorders_container").innerHTML = "";
    }
    if(!Configuration.spotshadow_feature_enabled){
        document.getElementById("menu_spotshadow_container").innerHTML = "";
    }
    if (!Configuration.findings_feature_enabled) {
        document.getElementById("menu_findings_container").innerHTML = "";
    }

    reload_all();
}

export function toggle_create_finding_mode(state:State) {
    if (state.state_creating_finding) {
        if ($("#set_asset_mode_alert").length == 0) {
            let html:string = `
            <div class="alert  alert-info collapse" role="alert" id="set_asset_mode_alert">
              <strong>Double click on the map to add a Finding.</strong>
              <button type="button" class="close" data-dismiss="alert" aria-label="Cancel">
                <span aria-hidden="true">Cancel</span>
              </button>
            </div>`;
            $("#alerts_container").append(html);
            $("#set_asset_mode_alert").on("closed.bs.alert", function () {
                Dispatcher.dispatch(Actions.SET_ADD_FINDINGS_STATE, false);
            });
        }
        $("#set_asset_mode_alert").show();
    }
    else {
        $("#set_asset_mode_alert").hide();
    }
    document.getElementById("map").style.cursor = state.mouse_cursor;
}
